<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- 统计条 -->
			<div class="process-stat-bar">
				<el-tag type="info" size="small">待确认：{{ statistic.waitConfirmCount || 0 }}</el-tag>
				<el-tag type="warning" size="small">待加工：{{ statistic.waitProcessCount || 0 }}</el-tag>
				<el-tag type="danger" size="small">采购中：{{ statistic.purchasingCount || 0 }}</el-tag>
				<el-tag size="small">加工中：{{ statistic.processingCount || 0 }}</el-tag>
				<el-tag type="success" size="small">已完成：{{ statistic.finishedCount || 0 }}</el-tag>
			</div>
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/processOrder/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/processOrder/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/processOrder/index', 'create')" size="small" type="primary" icon="el-icon-plus" @click="handleCreate">新建加工订单</el-button></template>
			<el-form-item label="需求门店：">
					<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="search">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单编号：">
					<el-input clearable v-model="formInline.orderNo" size="small" placeholder="请输入订单编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="加工类型：">
					<el-select v-model.number="formInline.processType" placeholder="请选择加工类型" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option v-for="item in processTypeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单状态：">
					<el-select v-model.number="formInline.state" placeholder="请选择订单状态" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客电话：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="下单时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="480" @get-data="getListData">
				<template #orderNo>
					<el-table-column align="center" label="订单编号" width="240">
						<template #default="scope">
							<el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">
								{{ scope.row.orderNo }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #processTypeStr>
					<el-table-column align="center" label="加工类型" width="100">
						<template #default="scope">
							<span v-if="scope.row.processType === 2" class="one_3">{{ scope.row.processTypeStr }}</span>
							<span v-else>{{ scope.row.processTypeStr }}</span>
						</template>
					</el-table-column>
				</template>
				<template #stateStr>
					<el-table-column align="center" label="订单状态" width="100">
						<template #default="scope">
							<span>{{ scope.row.stateStr || "--" }}</span>
						</template>
					</el-table-column>
				</template>
				<template #operate>
					<el-table-column align="center" label="操作" width="230" fixed="right">
						<template #default="scope">
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'detail')" type="text" size="small" @click="handleSeeDetail(scope.row)">详情</el-button>
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'edit') && canEdit(scope.row)" type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'confirm') && scope.row.state === 1" type="text" size="small" @click="handleConfirm(scope.row)">确认</el-button>
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'finished') && scope.row.state === 5" type="text" size="small" @click="handleFinished(scope.row)">完成</el-button>
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'cancel') && canCancel(scope.row)" type="text" size="small" class="text-danger" @click="handleCancel(scope.row)">撤单</el-button>
							<el-button v-if="$checkBtnPermission('/processOrder/index', 'delete') && scope.row.state === 1" type="text" size="small" class="text-danger" @click="handleDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>

		<processOrderEdit ref="processOrderEdit" @refresh-list="search"></processOrderEdit>
		<processOrderDetail ref="processOrderDetail" @refresh-list="search"></processOrderDetail>
	</div>
</template>

<script>
import { GetProcessOrderPageList, DeleteProcessOrder, ConfirmProcessOrder, CancelProcessOrder, FinishedProcessOrder, GetProcessOrderStatistic } from "@/api/processApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import processOrderEdit from "./edit.vue";
import processOrderDetail from "./detail.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "加工订单列表"
				}
			],
			pageShow: true,
			loading: false,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			dateValue: [],
			storeList: [],
			stateList: [],
			processTypeList: [],
			statistic: {},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				belongStoreKeyId: "",
				orderNo: "",
				processType: 0,
				state: 0,
				customerName: "",
				customerPhone: "",
				startTime: null,
				endTime: null
			},
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ slot: "orderNo", label: "订单编号", align: "center", isKeep: true, width: "240" },
				{ prop: "belongStoreName", label: "需求门店", align: "center", isKeep: true, width: "140" },
				{ slot: "processTypeStr", label: "加工类型", align: "center", isKeep: true, width: "100" },
				{ slot: "stateStr", label: "订单状态", align: "center", isKeep: true, width: "100" },
				{ prop: "machinTypeStr", label: "加工方式", align: "center", width: "110" },
				{ prop: "customerName", label: "顾客姓名", align: "center", width: "100" },
				{ prop: "customerPhone", label: "顾客电话", align: "center", width: "130" },
				{ prop: "jjInformation", label: "镜架信息", align: "center", minWidth: "140" },
				{ prop: "orderDate", label: "下单日期", align: "center", width: "160" },
				{ prop: "getOrderDate", label: "取单日期", align: "center", width: "160" },
				{ prop: "confirmUserName", label: "确认人", align: "center", width: "100" },
				{ prop: "confirmTime", label: "确认时间", align: "center", width: "160" },
				{ prop: "remark", label: "备注", align: "center", minWidth: "160" },
				{ prop: "creator", label: "创建人", align: "center", width: "100" },
				{ prop: "createTime", label: "创建时间", align: "center", width: "160" },
				{ slot: "operate", label: "操作", align: "center", isKeep: true, width: "230" }
			]
		};
	},
	components: {
		processOrderEdit,
		processOrderDetail
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getEnumConfigListByCode();
		this.getListData();
		this.getStatistic();
	},
	methods: {
			changePages(tab) {
				this.activeTab = tab;
			},
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 工厂店下拉：组织配置 key=2 即 IsSet2=工厂店
		GetOrgInfoListByConfig() {
			GetOrgInfoListByConfig({ key: 2 })
				.then((res) => {
					if (res.code == 1) {
						this.storeList = (res.data || []).map((item) => ({ keyId: item.keyId, value: item.name }));
					}
				})
				.catch(() => {
					this.$message.error("获取工厂店信息失败!");
				});
		},
		getEnumConfigListByCode() {
			GetEnumConfigListByCode({ code: "ProcessOrderState" })
				.then((res) => {
					if (res.code == 1) {
						this.stateList = res.data || [];
					}
				})
				.catch(() => {
					this.$message.error("获取订单状态失败!");
				});
			GetEnumConfigListByCode({ code: "ProcessType" })
				.then((res) => {
					if (res.code == 1) {
						this.processTypeList = res.data || [];
					}
				})
				.catch(() => {});
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 后端 int 型筛选字段不接受 null/空串（System.Text.Json 会直接返回 400），统一归一化为 0（0=不筛选）
		normalizeQuery() {
			["processType", "state"].forEach((key) => {
				const val = this.formInline[key];
				if (val === null || val === undefined || val === "") this.formInline[key] = 0;
			});
		},
		getListData() {
			this.normalizeQuery();
			this.loading = true;
			GetProcessOrderPageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		getStatistic() {
			GetProcessOrderStatistic({})
				.then((res) => {
					if (res.code == 1) {
						this.statistic = res.data || {};
					}
				})
				.catch(() => {});
		},
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.dateValue = [];
			this.search();
		},
		inputChange() {
			this.search();
		},
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
			this.getStatistic();
		},
		// 仅「待确认 / 已退回」可编辑
		canEdit(row) {
			return row.state === 1 || row.state === 2;
		},
		// 允许撤单：待确认 / 采购中 / 待加工
		canCancel(row) {
			return row.state === 1 || row.state === 3 || row.state === 4;
		},
		handleCreate() {
			this.$refs.processOrderEdit.showEditDialog(null, 1);
		},
		handleEdit(row) {
			this.$refs.processOrderEdit.showEditDialog(row, 2);
		},
		handleSeeDetail(row) {
			this.$refs.processOrderDetail.showSeeDetailDialog(row, 1);
		},
		handleConfirm(row) {
			this.$confirm(`确定要确认订单【${row.orderNo}】吗？确认后不可再编辑。`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					ConfirmProcessOrder({ keyIds: [row.keyId] })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "确认成功！" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleFinished(row) {
			this.$confirm(`确定要将订单【${row.orderNo}】标记为已完成吗？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					FinishedProcessOrder({ keyIds: [row.keyId] })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "操作成功！" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleCancel(row) {
			this.$prompt("请输入撤单原因（选填）", "撤单", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputType: "textarea"
			})
				.then(({ value }) => {
					this.loading = true;
					CancelProcessOrder({ keyId: row.keyId, remark: value || "" })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "撤单成功！" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		},
		handleDelete(row) {
			this.$confirm(`确定要删除订单【${row.orderNo}】吗？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					DeleteProcessOrder({ keyIds: [row.keyId] })
						.then((res) => {
							if (res.code == 1) {
								this.$message({ type: "success", message: "删除成功！" });
								this.search();
							} else {
								this.$message({ type: "info", message: res.msg });
							}
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped>
.process-stat-bar {
	margin-bottom: 10px;
}
.process-stat-bar .el-tag {
	margin-right: 10px;
}
.one_3 {
	padding: 2px 20px;
	background: var(--app-warning-soft);
	border: 1px solid var(--app-warning-border);
	color: var(--app-warning);
	border-radius: 2px;
}
.text-danger {
	color: var(--app-danger);
}
</style>
